module.exports = __webpack_public_path__ + "static/media/StartUpWorcesterLogo.ac14afa6.PNG";